import { faCheck, faComment, faTimes } from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import { Box } from '@domain-group/suit-theme'

import type { AttachmentModel } from '@models/types'

import OverlayBox from './OverlayBox'

interface AttachmentTileOverlayProps {
  attachment: AttachmentModel,
  hasFilteredComments: boolean,
}

const AttachmentTileOverlay = (props: AttachmentTileOverlayProps) => {
  const { attachment, hasFilteredComments } = props

  const reviewStatus = digObject(attachment, 'data.review_status', '')

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      position="absolute"
    >
      {hasFilteredComments && (
        <OverlayBox backgroundColor="orange" icon={faComment} />
      )}

      {reviewStatus === 'approved' && (
        <OverlayBox backgroundColor="green" icon={faCheck} />
      )}

      {reviewStatus === 'rejected' && (
        <OverlayBox backgroundColor="red" icon={faTimes} />
      )}
    </Box>
  )
}

export default AttachmentTileOverlay
